import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import PickerContainer from '../../containers/picker-container';
import PickerItem from '../../blocks/picker-item';

const PickerContainerBlock = props => <PickerContainer {...props} />;
PickerContainerBlock.displayName = 'PickerContainer';

export default withDynamicComponents({
  componentWhitelist: [
    PickerContainer,
    PickerItem,
  ],
  mapInputToOutput: [
    ['components', 'components'],
  ],
})(PickerContainerBlock);



// WEBPACK FOOTER //
// ./src/blocks/picker-container/index.jsx